/**
 * Utility for creating custom error classes
 * @module
 */

var createError = require('custom-error');

var BaseError = createError('InternalError');

/**
 * Base Error class from which all custom error classes derive
 * @constructor
 */
exports.BaseError = BaseError;

/**
 * Create a custom error class
 * @param {string} errorName Name of custom error class (reflected in name property)
 * @return {Error} Error subclass constructor
 */
exports.create = function(errorName:string): Error {
  return createError(errorName, BaseError);
};
